module.exports = __webpack_public_path__ + "static/media/warning_icon_yellow.0d676f62.svg";